import React from 'react';
import { Link } from 'react-router-dom'; // Added for navigation
import './FeatureLockOverlay.css'; // We'll create this CSS file next

const FeatureLockOverlay = ({ featureName, currentPlan }) => {
  const isFreePlan = !currentPlan || (
    currentPlan !== process.env.REACT_APP_PADDLE_PRO_MONTHLY && 
    currentPlan !== process.env.REACT_APP_PADDLE_PRO_YEARLY && 
    currentPlan !== process.env.REACT_APP_PADDLE_BUSINESS_MONTHLY &&
    currentPlan !== process.env.REACT_APP_PADDLE_BUSINESS_YEARLY
  );

  // If it's not a free plan, or if somehow this overlay is shown for a non-free user without a feature name,
  // don't render the overlay. This acts as a safeguard.
  // The primary logic to show/hide this component will be in the parent feature component.
  if (!isFreePlan && featureName) { 
    return null;
  }

  let message = "This functionality is available for users on our Pro or Business plans.";
  if (featureName) {
    message = `The \"${featureName}\" feature is available for users on our Pro or Business plans.`;
  }

  return (
    <div className="feature-lock-popup-local">
      <h2>{featureName ? `${featureName} is a Premium Feature` : "Premium Feature Locked"}</h2>
      <p>{message}</p>
      <p>Please upgrade your plan to unlock this and many more exciting features!</p>
      <Link to="/dashboard/upgrade" className="upgrade-button-overlay">
        Upgrade Plan
      </Link>
    </div>
  );
};

export default FeatureLockOverlay; 